var Vendd = (function (Vendd) {
    'use strict';

    Vendd.MessageBus.subscribe(Vendd.SalesRegistrationSystem.Messages.GetModel, Vendd.SalesRegistrationSystem, function (envelope) {
        function onSuccess(response) {
            if (response.success) {
                Vendd.MessageBus.publishAsync(Vendd.SalesRegistrationSystem, new Vendd.SalesRegistrationSystem.Messages.GetModelSuccess(response));
            } else {
                Vendd.MessageBus.publishAsync(Vendd.SalesRegistrationSystem, new Vendd.SalesRegistrationSystem.Messages.GetModelFailed(response));
            }
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(Vendd.SalesRegistrationSystem, new Vendd.SalesRegistrationSystem.Messages.GetModelFailed(response));
        }
        var options = {
            method: 'POST',
            url: 'api/SalesRegistrationSystem/GetModel',
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        Vendd.Service.call(options);
    });

	return Vendd;

})(Vendd || {});